import { render, staticRenderFns } from "./dropdown-wrapper.vue?vue&type=template&id=53f3428d"
import script from "./dropdown-wrapper.vue?vue&type=script&lang=js"
export * from "./dropdown-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports